import React from 'react';

export type Color =
  | 'primary'
  | 'secondary'
  | 'accent'
  | 'danger'
  | 'white'
  | 'success'
  | 'gray'
  | 'orange'
  | 'green'
  | 'darkgray';

type IconProps = {
  name: string;
  color?: Color;
  size?: number;
  baseSize?: number;
  disabled?: boolean;
  className?: string;
  outline?: boolean;
  viewBox?: string;
};

export const IconLibrary: React.FC = () => (
  <svg style={{ display: 'none' }}>
    <defs>
      <symbol id="list">
        <path
          transform="translate(4, 4)"
          d="M14.6667 17.3327H1.33333C1.11232 17.3327 0.900358 17.2449 0.744078 17.0886C0.587797 16.9323 0.5 16.7204 0.5 16.4993V1.49935C0.5 1.27834 0.587797 1.06637 0.744078 0.910093C0.900358 0.753813 1.11232 0.666016 1.33333 0.666016H14.6667C14.8877 0.666016 15.0996 0.753813 15.2559 0.910093C15.4122 1.06637 15.5 1.27834 15.5 1.49935V16.4993C15.5 16.7204 15.4122 16.9323 15.2559 17.0886C15.0996 17.2449 14.8877 17.3327 14.6667 17.3327ZM13.8333 15.666V2.33268H2.16667V15.666H13.8333ZM4.66667 4.83268H11.3333V6.49935H4.66667V4.83268ZM4.66667 8.16602H11.3333V9.83268H4.66667V8.16602ZM4.66667 11.4993H11.3333V13.166H4.66667V11.4993Z"
          fill="#374151"
        />
      </symbol>
      <symbol id="plus">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <polygon points="0 0 24 0 24 24 0 24" />
          <polygon
            fill="currentcolor"
            fillRule="nonzero"
            points="11 11 11 5 13 5 13 11 19 11 19 13 13 13 13 19 11 19 11 13 5 13 5 11"
          />
        </g>
      </symbol>
      <symbol id="arrow-left">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <polygon points="0 0 24 0 24 24 0 24" />
          <polygon
            fill="currentcolor"
            fillRule="nonzero"
            points="7.828 11 20 11 20 13 7.828 13 13.192 18.364 11.778 19.778 4 12 11.778 4.222 13.192 5.636"
          />
        </g>
      </symbol>
      <symbol id="arrow-right">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <polygon points="0 0 24 0 24 24 0 24" />
          <polygon
            fill="currentcolor"
            fillRule="nonzero"
            points="16.172 11 10.808 5.636 12.222 4.222 20 12 12.222 19.778 10.808 18.364 16.172 13 4 13 4 11"
          />
        </g>
      </symbol>
      <symbol id="point-arrow-right">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <polygon points="0 0 24 0 24 24 0 24" />
          <path
            fill="currentcolor"
            fillRule="nonzero"
            d="M6.3641 9L0 2.38859L1.81795 0.5L10 9L1.81795 17.5L0 15.6114L6.3641 9Z"
          />
        </g>
      </symbol>
      <symbol id="arrow-up">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <polygon points="0 0 24 0 24 24 0 24" />
          <polygon
            fill="currentcolor"
            fillRule="nonzero"
            points="12 10.828 7.05 15.778 5.636 14.364 12 8 18.364 14.364 16.95 15.778"
          />
        </g>
      </symbol>
      <symbol id="arrow-down">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <polygon points="0 0 24 0 24 24 0 24" />
          <polygon
            fill="currentcolor"
            fillRule="nonzero"
            points="12 13.172 16.95 8.222 18.364 9.636 12 16 5.636 9.636 7.05 8.222"
          />
        </g>
      </symbol>
      <symbol id="close">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <polygon points="0 0 24 0 24 24 0 24" />
          <polygon
            fill="currentcolor"
            fillRule="nonzero"
            points="12 10.586 16.95 5.636 18.364 7.05 13.414 12 18.364 16.95 16.95 18.364 12 13.414 7.05 18.364 5.636 16.95 10.586 12 5.636 7.05 7.05 5.636"
          />
        </g>
      </symbol>
      <symbol id="close-rounded">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <polygon points="0 0 24 0 24 24 0 24" />
          <path
            d="M12,22 C6.477,22 2,17.523 2,12 C2,6.477 6.477,2 12,2 C17.523,2 22,6.477 22,12 C22,17.523 17.523,22 12,22 Z M12,10.586 L9.172,7.757 L7.757,9.172 L10.586,12 L7.757,14.828 L9.172,16.243 L12,13.414 L14.828,16.243 L16.243,14.828 L13.414,12 L16.243,9.172 L14.828,7.757 L12,10.586 Z"
            fill="currentcolor"
            fillRule="nonzero"
          />
        </g>
      </symbol>
      <symbol id="check">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <polygon points="0 0 24 0 24 24 0 24" />
          <polygon
            fill="currentcolor"
            fillRule="nonzero"
            points="10 15.172 19.192 5.979 20.607 7.393 10 18 3.636 11.636 5.05 10.222"
          />
        </g>
      </symbol>
      <symbol id="check-rounded">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <polygon points="0 0 24 0 24 24 0 24" />
          <path
            d="M12,22 C6.477,22 2,17.523 2,12 C2,6.477 6.477,2 12,2 C17.523,2 22,6.477 22,12 C22,17.523 17.523,22 12,22 Z M11.003,16 L18.073,8.929 L16.659,7.515 L11.003,13.172 L8.174,10.343 L6.76,11.757 L11.003,16 Z"
            fill="currentColor"
            fillRule="nonzero"
          />
        </g>
      </symbol>
      <symbol id="headphones">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <polygon points="0 0 24 0 24 24 0 24" />
          <path
            d="M22,17.002 C21.9990836,19.8193915 20.038652,22.2569322 17.287,22.862 L16.649,20.948 C17.8320293,20.7531538 18.8654303,20.0382869 19.465,19 L17,19 C15.8954305,19 15,18.1045695 15,17 L15,13 C15,11.8954305 15.8954305,11 17,11 L19.938,11 C19.4330948,7.00036736 16.0313758,4.00107634 12,4.00107634 C7.96862424,4.00107634 4.56690517,7.00036736 4.062,11 L7,11 C8.1045695,11 9,11.8954305 9,13 L9,17 C9,18.1045695 8.1045695,19 7,19 L4,19 C2.8954305,19 2,18.1045695 2,17 L2,12 C2,6.477 6.477,2 12,2 C17.523,2 22,6.477 22,12 L22,17.002 Z"
            fill="currentcolor"
            fillRule="nonzero"
          />
        </g>
      </symbol>
      <symbol id="calendar">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <polygon points="0 0 24 0 24 24 0 24" />
          <path
            d="M17,3 L21,3 C21.5522847,3 22,3.44771525 22,4 L22,20 C22,20.5522847 21.5522847,21 21,21 L3,21 C2.44771525,21 2,20.5522847 2,20 L2,4 C2,3.44771525 2.44771525,3 3,3 L7,3 L7,1 L9,1 L9,3 L15,3 L15,1 L17,1 L17,3 Z M15,5 L9,5 L9,7 L7,7 L7,5 L4,5 L4,9 L20,9 L20,5 L17,5 L17,7 L15,7 L15,5 Z M20,11 L4,11 L4,19 L20,19 L20,11 Z"
            fill="currentcolor"
            fillRule="nonzero"
          />
        </g>
      </symbol>
      <symbol id="cart">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <polygon points="0 0 24 0 24 24 0 24" />
          <path
            d="M4,6.414 L0.757,3.172 L2.172,1.757 L5.414,5 L20.656,5 C20.9720542,4.99997806 21.269516,5.14936872 21.4582332,5.40289595 C21.6469504,5.65642317 21.7047076,5.98424203 21.614,6.287 L19.214,14.287 C19.0872125,14.7101833 18.6977682,15.0000307 18.256,15 L6,15 L6,17 L17,17 L17,19 L5,19 C4.44771525,19 4,18.5522847 4,18 L4,6.414 Z M6,7 L6,13 L17.512,13 L19.312,7 L6,7 Z M5.5,23 C4.67157288,23 4,22.3284271 4,21.5 C4,20.6715729 4.67157288,20 5.5,20 C6.32842712,20 7,20.6715729 7,21.5 C7,22.3284271 6.32842712,23 5.5,23 Z M17.5,23 C16.6715729,23 16,22.3284271 16,21.5 C16,20.6715729 16.6715729,20 17.5,20 C18.3284271,20 19,20.6715729 19,21.5 C19,22.3284271 18.3284271,23 17.5,23 Z"
            fill="currentcolor"
            fillRule="nonzero"
          />
          <circle cx="20" cy="4" r="4" />
        </g>
      </symbol>
      <symbol id="cart-filled">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <polygon points="0 0 24 0 24 24 0 24" />
          <path
            d="M4,6.414 L0.757,3.172 L2.172,1.757 L5.414,5 L20.656,5 C20.9720542,4.99997806 21.269516,5.14936872 21.4582332,5.40289595 C21.6469504,5.65642317 21.7047076,5.98424203 21.614,6.287 L19.214,14.287 C19.0872125,14.7101833 18.6977682,15.0000307 18.256,15 L6,15 L6,17 L17,17 L17,19 L5,19 C4.44771525,19 4,18.5522847 4,18 L4,6.414 Z M5.5,23 C4.67157288,23 4,22.3284271 4,21.5 C4,20.6715729 4.67157288,20 5.5,20 C6.32842712,20 7,20.6715729 7,21.5 C7,22.3284271 6.32842712,23 5.5,23 Z M17.5,23 C16.6715729,23 16,22.3284271 16,21.5 C16,20.6715729 16.6715729,20 17.5,20 C18.3284271,20 19,20.6715729 19,21.5 C19,22.3284271 18.3284271,23 17.5,23 Z"
            fill="currentcolor"
            fillRule="nonzero"
          />
        </g>
      </symbol>
      <symbol id="bell">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <polygon points="0 0 24 0 24 24 0 24" />
          <path
            d="M5,18 L19,18 L19,11.031 C19,7.148 15.866,4 12,4 C8.134,4 5,7.148 5,11.031 L5,18 Z M12,2 C16.97,2 21,6.043 21,11.031 L21,20 L3,20 L3,11.031 C3,6.043 7.03,2 12,2 Z M9.5,21 L14.5,21 C14.5,22.3807119 13.3807119,23.5 12,23.5 C10.6192881,23.5 9.5,22.3807119 9.5,21 L9.5,21 Z"
            fill="currentcolor"
            fillRule="nonzero"
          />
          <circle cx="20" cy="4" r="4" />
        </g>
      </symbol>
      <symbol id="bell-filled">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <polygon points="0 0 24 0 24 24 0 24" />
          <path
            d="M12,2 C16.97,2 21,6.043 21,11.031 L21,20 L3,20 L3,11.031 C3,6.043 7.03,2 12,2 Z M9.5,21 L14.5,21 C14.5,22.3807119 13.3807119,23.5 12,23.5 C10.6192881,23.5 9.5,22.3807119 9.5,21 L9.5,21 Z"
            fill="currentcolor"
            fillRule="nonzero"
          />
        </g>
      </symbol>
      <symbol id="male">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <polygon points="0 0 24 0 24 24 0 24" />
          <path
            d="M15.05,8.537 L18.585,5 L14,5 L14,3 L22,3 L22,11 L20,11 L20,6.414 L16.463,9.951 C18.857361,13.0896243 18.4088537,17.5470177 15.4371984,20.1457081 C12.4655431,22.7443986 7.98814468,22.5946732 5.19673577,19.8032642 C2.40532685,17.0118553 2.25560142,12.5344569 4.85429188,9.56280161 C7.45298235,6.59114629 11.9103757,6.14263897 15.049,8.537 L15.05,8.537 Z M10.5,20 C13.5375661,20 16,17.5375661 16,14.5 C16,11.4624339 13.5375661,9 10.5,9 C7.46243388,9 5,11.4624339 5,14.5 C5,17.5375661 7.46243388,20 10.5,20 Z"
            fill="currentcolor"
            fillRule="nonzero"
          />
        </g>
      </symbol>
      <symbol id="female">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <polygon points="0 0 24 0 24 24 0 24" />
          <path
            d="M11,15.934 C7.0905703,15.4039962 4.25987229,11.9362191 4.52345723,7.99984165 C4.78704217,4.06346418 8.05480948,1.00404829 12,0.999996451 C15.9504155,0.996191775 19.2265381,4.05731842 19.4904721,7.99890893 C19.7544061,11.9404994 16.9156555,15.4110859 13,15.934 L13,17.9999965 L18,17.9999965 L18,19.9999965 L13,19.9999965 L13,23.9999965 L11,23.9999965 L11,19.9999965 L6,19.9999965 L6,17.9999965 L11,17.9999965 L11,15.934 Z M12,14 C15.0375661,14 17.5,11.5375661 17.5,8.5 C17.5,5.46243388 15.0375661,3 12,3 C8.96243388,3 6.5,5.46243388 6.5,8.5 C6.5,11.5375661 8.96243388,14 12,14 Z"
            fill="currentcolor"
            fillRule="nonzero"
          />
        </g>
      </symbol>
      <symbol id="back">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <polygon points="0 0 24 0 24 24 0 24" />
          <path
            d="M5.828,7 L8.364,9.536 L6.95,10.95 L2,6 L6.95,1.05 L8.364,2.464 L5.828,5 L13,5 C17.418278,5 21,8.581722 21,13 C21,17.418278 17.418278,21 13,21 L4,21 L4,19 L13,19 C16.3137085,19 19,16.3137085 19,13 C19,9.6862915 16.3137085,7 13,7 L5.828,7 Z"
            fill="currentcolor"
            fillRule="nonzero"
          />
        </g>
      </symbol>
      <symbol id="profile">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <path
            transform="translate(4, 2)"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 12C4.685 12 2 9.315 2 6C2 2.685 4.685 0 8 0C11.315 0 14 2.685 14 6C14 9.315 11.315 12 8 12ZM0 21C0 16.5817 3.58172 13 8 13C12.4183 13 16 16.5817 16 21H14C14 17.6863 11.3137 15 8 15C4.68629 15 2 17.6863 2 21H0ZM12 6C12 8.21 10.21 10 8 10C5.79 10 4 8.21 4 6C4 3.79 5.79 2 8 2C10.21 2 12 3.79 12 6Z"
            fill="currentcolor"
          />
        </g>
      </symbol>
      <symbol id="question-mark">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <polygon points="0 0 24 0 24 24 0 24" />
          <path
            d="M12,22 C6.477,22 2,17.523 2,12 C2,6.477 6.477,2 12,2 C17.523,2 22,6.477 22,12 C22,17.523 17.523,22 12,22 Z M11,15 L11,17 L13,17 L13,15 L11,15 Z M13,13.355 C14.6610148,12.8543757 15.705157,11.2131154 15.4547342,9.49646657 C15.2043113,7.77981775 13.7348104,6.50524497 12,6.5 C10.3315752,6.49987284 8.89487097,7.6771082 8.567,9.313 L10.529,9.706 C10.6838697,8.93117447 11.4132539,8.40934647 12.1965836,8.51294995 C12.9799134,8.61655344 13.5485571,9.31005909 13.4966679,10.0985049 C13.4447788,10.8869506 12.7901514,11.4999504 12,11.5 C11.4477153,11.5 11,11.9477153 11,12.5 L11,14 L13,14 L13,13.355 Z"
            fill="currentcolor"
            fillRule="nonzero"
          />
        </g>
      </symbol>
      <symbol id="exclamation-mark">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <polygon points="0 0 24 0 24 24 0 24" />
          <path
            d="M12,22 C6.477,22 2,17.523 2,12 C2,6.477 6.477,2 12,2 C17.523,2 22,6.477 22,12 C22,17.523 17.523,22 12,22 Z M11,15 L11,17 L13,17 L13,15 L11,15 Z M11,7 L11,13 L13,13 L13,7 L11,7 Z"
            fill="currentcolor"
            fillRule="nonzero"
          />
        </g>
      </symbol>
      <symbol id="edit">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <polygon points="0 0 24 0 24 24 0 24" />
          <path
            d="M15.728,9.686 L14.314,8.272 L5,17.586 L5,19 L6.414,19 L15.728,9.686 Z M17.142,8.272 L18.556,6.858 L17.142,5.444 L15.728,6.858 L17.142,8.272 Z M7.242,21 L3,21 L3,16.757 L16.435,3.322 C16.8254999,2.93161806 17.4585001,2.93161806 17.849,3.322 L20.678,6.151 C21.0683819,6.54149985 21.0683819,7.17450015 20.678,7.565 L7.243,21 L7.242,21 Z"
            fill="currentcolor"
            fillRule="nonzero"
          />
        </g>
      </symbol>
      <symbol id="save">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <polygon points="0 0 24 0 24 24 0 24" />
          <path
            d="M4,3 L18,3 L20.707,5.707 C20.8945494,5.89449273 21,6.14880519 21,6.414 L21,20 C21,20.5522847 20.5522847,21 20,21 L4,21 C3.44771525,21 3,20.5522847 3,20 L3,4 C3,3.44771525 3.44771525,3 4,3 Z M7,4 L7,9 L16,9 L16,4 L7,4 Z M6,12 L6,19 L18,19 L18,12 L6,12 Z M13,5 L15,5 L15,8 L13,8 L13,5 Z"
            fill="currentcolor"
            fillRule="nonzero"
          />
        </g>
      </symbol>
      <symbol id="menu">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <polygon points="0 0 24 0 24 24 0 24" />
          <path
            d="M3,4 L21,4 L21,6 L3,6 L3,4 Z M3,11 L21,11 L21,13 L3,13 L3,11 Z M3,18 L21,18 L21,20 L3,20 L3,18 Z"
            fill="currentcolor"
            fillRule="nonzero"
          />
        </g>
      </symbol>
      <symbol id="search">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <polygon points="0 0 24 0 24 24 0 24" />
          <path
            d="M18.031,16.617 L22.314,20.899 L20.899,22.314 L16.617,18.031 C15.0237382,19.3082211 13.0420011,20.0029052 11,20 C6.032,20 2,15.968 2,11 C2,6.032 6.032,2 11,2 C15.968,2 20,6.032 20,11 C20.0029052,13.0420011 19.3082211,15.0237382 18.031,16.617 Z M16.025,15.875 C17.2941129,14.5698857 18.002867,12.8204293 18,11 C18,7.132 14.867,4 11,4 C7.132,4 4,7.132 4,11 C4,14.867 7.132,18 11,18 C12.8204293,18.002867 14.5698857,17.2941129 15.875,16.025 L16.025,15.875 L16.025,15.875 Z"
            fill="currentcolor"
            fillRule="nonzero"
          />
        </g>
      </symbol>
      <symbol id="cog">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <polygon points="0 0 24 0 24 24 0 24" />
          <path
            d="M3.34,17 C2.91727068,16.2689845 2.58866483,15.4874536 2.362,14.674 C3.36787109,14.1624039 4.00154995,13.1296107 4.00197206,12.001113 C4.00239416,10.8726154 3.36948809,9.83934842 2.364,9.327 C2.8160359,7.69248655 3.67672961,6.19995213 4.865,4.99 C5.81130986,5.60523104 7.02285501,5.63723881 8.00032966,5.07283215 C8.97780432,4.50842549 9.55575699,3.44313827 9.496,2.316 C11.1381096,1.89162213 12.8612299,1.89231041 14.503,2.318 C14.4437716,3.44511309 15.0221644,4.51008838 15.9998287,5.0740605 C16.9774929,5.63803262 18.1889612,5.60555062 19.135,4.99 C19.714,5.58 20.228,6.251 20.66,7 C21.093,7.749 21.417,8.53 21.638,9.326 C20.6321289,9.83759609 19.99845,10.8703893 19.9980279,11.998887 C19.9976058,13.1273846 20.6305119,14.1606516 21.636,14.673 C21.1839641,16.3075135 20.3232704,17.8000479 19.135,19.01 C18.1886901,18.394769 16.977145,18.3627612 15.9996703,18.9271679 C15.0221957,19.4915745 14.444243,20.5568617 14.504,21.684 C12.8618904,22.1083779 11.1387701,22.1076896 9.497,21.682 C9.55622838,20.5548869 8.97783558,19.4899116 8.00017134,18.9259395 C7.02250711,18.3619674 5.81103877,18.3944494 4.865,19.01 C4.27399091,18.4069452 3.76159493,17.7315905 3.34,17 Z M9,17.196 C10.0656269,17.8106284 10.8668451,18.797017 11.25,19.966 C11.749,20.013 12.25,20.014 12.749,19.967 C13.1324026,18.7978533 13.9339962,17.8114409 15,17.197 C16.0652173,16.5806856 17.3205228,16.3794806 18.525,16.632 C18.815,16.224 19.065,15.789 19.273,15.334 C18.4524296,14.4174411 17.9991165,13.2302094 18,12 C18,10.74 18.47,9.563 19.273,8.666 C19.0635289,8.21114808 18.8124608,7.77663289 18.523,7.368 C17.3192831,7.62030887 16.0647924,7.41947642 15,6.804 C13.9343731,6.18937156 13.1331549,5.20298298 12.75,4.034 C12.251,3.987 11.75,3.986 11.251,4.033 C10.8675974,5.20214671 10.0660038,6.18855915 9,6.803 C7.93478271,7.41931437 6.67947717,7.62051937 5.475,7.368 C5.18556554,7.77628559 4.9351317,8.21086197 4.727,8.666 C5.5475704,9.58255892 6.0008835,10.7697906 6,12 C6,13.26 5.53,14.437 4.727,15.334 C4.93647108,15.7888519 5.18753918,16.2233671 5.477,16.632 C6.68071691,16.3796911 7.93520756,16.5805236 9,17.196 Z M12,15 C10.3431458,15 9,13.6568542 9,12 C9,10.3431458 10.3431458,9 12,9 C13.6568542,9 15,10.3431458 15,12 C15,13.6568542 13.6568542,15 12,15 Z M12,13 C12.5522847,13 13,12.5522847 13,12 C13,11.4477153 12.5522847,11 12,11 C11.4477153,11 11,11.4477153 11,12 C11,12.5522847 11.4477153,13 12,13 Z"
            fill="currentColor"
            fillRule="nonzero"
          />
        </g>
      </symbol>
      <symbol id="heart">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <polygon id="Path" points="0 0 24 0 24 24 0 24" />
          <path
            d="M16.5,3 C19.538,3 22,5.5 22,9 C22,16 14.5,20 12,21.5 C9.5,20 2,16 2,9 C2,5.5 4.5,3 7.5,3 C9.36,3 11,4 12,5 C13,4 14.64,3 16.5,3 Z M12.934,18.604 C13.815,18.048 14.61,17.495 15.354,16.903 C18.335,14.533 20,11.943 20,9 C20,6.64 18.463,5 16.5,5 C15.424,5 14.26,5.57 13.414,6.414 L12,7.828 L10.586,6.414 C9.74,5.57 8.576,5 7.5,5 C5.56,5 4,6.656 4,9 C4,11.944 5.666,14.533 8.645,16.903 C9.39,17.495 10.185,18.048 11.066,18.603 C11.365,18.792 11.661,18.973 12,19.175 C12.339,18.973 12.635,18.792 12.934,18.604 L12.934,18.604 Z"
            fill="currentColor"
            fillRule="nonzero"
          />
        </g>
      </symbol>
      <symbol id="home">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <polygon points="0 0 24 0 24 24 0 24" />
          <path
            d="M20.9999998,20 C20.9999998,20.5522847 20.5522847,21 19.9999998,21 L3.99999976,21 C3.44771525,21 2.99999976,20.5522847 2.99999976,20 L2.99999976,9.49 C2.99978575,9.1811923 3.1422561,8.8896079 3.386,8.7 L11.386,2.478 C11.7471336,2.1970747 12.2528664,2.1970747 12.614,2.478 L20.614,8.7 C20.8577439,8.8896079 21.0002142,9.1811923 20.9999998,9.49 L20.9999998,20 L20.9999998,20 Z M19,19 L19,9.978 L12,4.534 L5,9.978 L5,19 L19,19 Z"
            fill="currentColor"
            fillRule="nonzero"
          />
        </g>
      </symbol>
      <symbol id="bank">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <path fill="none" d="M0 0h24v24H0z" />
          <path
            d="M2 20h20v2H2v-2zm2-8h2v7H4v-7zm5 0h2v7H9v-7zm4 0h2v7h-2v-7zm5 0h2v7h-2v-7zM2 7l10-5 10 5v4H2V7zm2 1.236V9h16v-.764l-8-4-8 4zM12 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
            fill="currentColor"
            fillRule="nonzero"
          />
        </g>
      </symbol>
      <symbol id="folder-download">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <path fill="none" d="M0 0h24v24H0z" />
          <path
            d="M12.414 5H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h7.414l2 2zM4 5v14h16V7h-8.414l-2-2H4zm9 8h3l-4 4-4-4h3V9h2v4z"
            fill="currentColor"
            fillRule="nonzero"
          />
        </g>
      </symbol>
      <symbol id="key">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <path fill="none" d="M0 0h24v24H0z" />
          <path
            d="M12.917 13A6.002 6.002 0 0 1 1 12a6 6 0 0 1 11.917-1H23v2h-2v4h-2v-4h-2v4h-2v-4h-2.083zM7 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"
            fill="currentColor"
            fillRule="nonzero"
          />
        </g>
      </symbol>
      <symbol id="logout">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <path fill="none" d="M0 0h24v24H0z" />
          <path
            d="M5 11h8v2H5v3l-5-4 5-4v3zm-1 7h2.708a8 8 0 1 0 0-12H4A9.985 9.985 0 0 1 12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10a9.985 9.985 0 0 1-8-4z"
            fill="currentColor"
            fillRule="nonzero"
          />
        </g>
      </symbol>
      <symbol id="mail">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <path fill="none" d="M0 0h24v24H0z" />
          <path
            d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm17 4.238l-7.928 7.1L4 7.216V19h16V7.238zM4.511 5l7.55 6.662L19.502 5H4.511z"
            fill="currentColor"
            fillRule="nonzero"
          />
        </g>
      </symbol>
      <symbol id="phone">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <path fill="none" d="M0 0h24v24H0z" />
          <path
            d="M9.366 10.682a10.556 10.556 0 0 0 3.952 3.952l.884-1.238a1 1 0 0 1 1.294-.296 11.422 11.422 0 0 0 4.583 1.364 1 1 0 0 1 .921.997v4.462a1 1 0 0 1-.898.995c-.53.055-1.064.082-1.602.082C9.94 21 3 14.06 3 5.5c0-.538.027-1.072.082-1.602A1 1 0 0 1 4.077 3h4.462a1 1 0 0 1 .997.921A11.422 11.422 0 0 0 10.9 8.504a1 1 0 0 1-.296 1.294l-1.238.884zm-2.522-.657l1.9-1.357A13.41 13.41 0 0 1 7.647 5H5.01c-.006.166-.009.333-.009.5C5 12.956 11.044 19 18.5 19c.167 0 .334-.003.5-.01v-2.637a13.41 13.41 0 0 1-3.668-1.097l-1.357 1.9a12.442 12.442 0 0 1-1.588-.75l-.058-.033a12.556 12.556 0 0 1-4.702-4.702l-.033-.058a12.442 12.442 0 0 1-.75-1.588z"
            fill="currentColor"
            fillRule="nonzero"
          />
        </g>
      </symbol>
      <symbol id="upload">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <path fill="none" d="M0 0h24v24H0z" />
          <path
            d="M4 19h16v-7h2v8a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-8h2v7zm9-10v7h-2V9H6l6-6 6 6h-5z"
            fill="currentColor"
            fillRule="nonzero"
          />
        </g>
      </symbol>

      <symbol id="uploadDoc">
        <path
          transform="translate(2, 0)"
          d="M13 0L18 5V19.008C17.9997 19.2712 17.895 19.5235 17.7088 19.7095C17.5226 19.8955 17.2702 20 17.007 20H0.993C0.730378 19.9982 0.479017 19.8931 0.293218 19.7075C0.107418 19.5219 0.00209465 19.2706 0 19.008V0.992C0 0.444 0.445 0 0.993 0H13ZM10 10H13L9 6L5 10H8V14H10V10Z"
        />
      </symbol>

      <symbol id="uploadDocWithOutline">
        <path
          d="M10.5 2.33317H2.16667V15.6665H13.8333V5.6665H10.5V2.33317ZM0.5 1.49317C0.5 1.0365 0.8725 0.666504 1.3325 0.666504H11.3333L15.5 4.83317V16.494C15.5008 16.6034 15.48 16.712 15.4388 16.8134C15.3976 16.9148 15.3369 17.007 15.2601 17.085C15.1832 17.1629 15.0918 17.2249 14.991 17.2675C14.8902 17.3101 14.7819 17.3324 14.6725 17.3332H1.3275C1.10865 17.3316 0.899181 17.2441 0.744348 17.0894C0.589515 16.9347 0.501746 16.7254 0.5 16.5065V1.49317ZM8.83333 8.99984V12.3332H7.16667V8.99984H4.66667L8 5.6665L11.3333 8.99984H8.83333Z"
          fill="currentColor"
        />
      </symbol>

      <symbol id="download">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <path fill="none" d="M0 0h24v24H0z" />
          <path
            d="M3 19h18v2H3v-2zm10-5.828L19.071 7.1l1.414 1.414L12 17 3.515 8.515 4.929 7.1 11 13.17V2h2v11.172z"
            fill="currentColor"
            fillRule="nonzero"
          />
        </g>
      </symbol>
      <symbol id="user">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <path fill="none" d="M0 0h24v24H0z" />
          <path
            d="M4 22a8 8 0 1 1 16 0h-2a6 6 0 1 0-12 0H4zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4z"
            fill="currentColor"
            fillRule="nonzero"
          />
        </g>
      </symbol>
      <symbol id="refresh">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <path fill="none" d="M0 0h24v24H0z" />
          <path
            d="M2.59725 2.32476C3.95817 1.1455 5.69924 0.497495 7.5 0.500007C11.6423 0.500007 15 3.85776 15 8.00001C15 9.60201 14.4975 11.087 13.6425 12.305L11.25 8.00001H13.5C13.5001 6.82373 13.1544 5.67336 12.506 4.69195C11.8576 3.71054 10.9349 2.94138 9.85288 2.4801C8.77082 2.01882 7.57704 1.88578 6.41997 2.09752C5.2629 2.30926 4.19359 2.85643 3.345 3.67101L2.59725 2.32476ZM12.4028 13.6753C11.0418 14.8545 9.30076 15.5025 7.5 15.5C3.35775 15.5 0 12.1423 0 8.00001C0 6.39801 0.5025 4.91301 1.3575 3.69501L3.75 8.00001H1.5C1.4999 9.17629 1.84556 10.3267 2.494 11.3081C3.14244 12.2895 4.06505 13.0586 5.14712 13.5199C6.22918 13.9812 7.42296 14.1142 8.58003 13.9025C9.7371 13.6908 10.8064 13.1436 11.655 12.329L12.4028 13.6753Z"
            fill="currentColor"
            fillRule="nonzero"
          />
        </g>
      </symbol>
      <symbol id="bill">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <path fill="none" d="M0 0h24v24H0z" />
          <path
            transform="translate(4, 0)"
            d="M14.6667 17.3327H1.33333C1.11232 17.3327 0.900358 17.2449 0.744078 17.0886C0.587797 16.9323 0.5 16.7204 0.5 16.4993V1.49935C0.5 1.27834 0.587797 1.06637 0.744078 0.910093C0.900358 0.753813 1.11232 0.666016 1.33333 0.666016H14.6667C14.8877 0.666016 15.0996 0.753813 15.2559 0.910093C15.4122 1.06637 15.5 1.27834 15.5 1.49935V16.4993C15.5 16.7204 15.4122 16.9323 15.2559 17.0886C15.0996 17.2449 14.8877 17.3327 14.6667 17.3327ZM13.8333 15.666V2.33268H2.16667V15.666H13.8333ZM4.66667 6.49935H11.3333V8.16602H4.66667V6.49935ZM4.66667 9.83268H11.3333V11.4993H4.66667V9.83268Z"
            fill="currentColor"
            fillRule="nonzero"
          />
        </g>
      </symbol>
      <symbol id="dots">
        <circle cx="10" cy="10" r="10" />
        <path
          transform="translate(3, 8)"
          d="M2.00036 0.638672C1.25036 0.638672 0.636719 1.25231 0.636719 2.00231C0.636719 2.75231 1.25036 3.36594 2.00036 3.36594C2.75036 3.36594 3.36399 2.75231 3.36399 2.00231C3.36399 1.25231 2.75036 0.638672 2.00036 0.638672ZM11.5458 0.638672C10.7958 0.638672 10.1822 1.25231 10.1822 2.00231C10.1822 2.75231 10.7958 3.36594 11.5458 3.36594C12.2958 3.36594 12.9094 2.75231 12.9094 2.00231C12.9094 1.25231 12.2958 0.638672 11.5458 0.638672ZM6.77308 0.638672C6.02308 0.638672 5.40945 1.25231 5.40945 2.00231C5.40945 2.75231 6.02308 3.36594 6.77308 3.36594C7.52308 3.36594 8.13672 2.75231 8.13672 2.00231C8.13672 1.25231 7.52308 0.638672 6.77308 0.638672Z"
          fill="white"
        />
      </symbol>

      <symbol id="circle">
        <circle cx="10" cy="10" r="9.5" fill="none" />
      </symbol>

      <symbol id="tick">
        <path d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM9.003 14L16.073 6.929L14.659 5.515L9.003 11.172L6.174 8.343L4.76 9.757L9.003 14Z" />
      </symbol>

      <symbol id="dollar">
        <path d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM6.5 12V14H9V16H11V14H12C12.663 14 13.2989 13.7366 13.7678 13.2678C14.2366 12.7989 14.5 12.163 14.5 11.5C14.5 10.837 14.2366 10.2011 13.7678 9.73223C13.2989 9.26339 12.663 9 12 9H8C7.86739 9 7.74021 8.94732 7.64645 8.85355C7.55268 8.75979 7.5 8.63261 7.5 8.5C7.5 8.36739 7.55268 8.24021 7.64645 8.14645C7.74021 8.05268 7.86739 8 8 8H13.5V6H11V4H9V6H8C7.33696 6 6.70107 6.26339 6.23223 6.73223C5.76339 7.20107 5.5 7.83696 5.5 8.5C5.5 9.16304 5.76339 9.79893 6.23223 10.2678C6.70107 10.7366 7.33696 11 8 11H12C12.1326 11 12.2598 11.0527 12.3536 11.1464C12.4473 11.2402 12.5 11.3674 12.5 11.5C12.5 11.6326 12.4473 11.7598 12.3536 11.8536C12.2598 11.9473 12.1326 12 12 12H6.5Z" />
      </symbol>

      <symbol id="cross">
        <path d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM6.5 12V14H9V16H11V14H12C12.663 14 13.2989 13.7366 13.7678 13.2678C14.2366 12.7989 14.5 12.163 14.5 11.5C14.5 10.837 14.2366 10.2011 13.7678 9.73223C13.2989 9.26339 12.663 9 12 9H8C7.86739 9 7.74021 8.94732 7.64645 8.85355C7.55268 8.75979 7.5 8.63261 7.5 8.5C7.5 8.36739 7.55268 8.24021 7.64645 8.14645C7.74021 8.05268 7.86739 8 8 8H13.5V6H11V4H9V6H8C7.33696 6 6.70107 6.26339 6.23223 6.73223C5.76339 7.20107 5.5 7.83696 5.5 8.5C5.5 9.16304 5.76339 9.79893 6.23223 10.2678C6.70107 10.7366 7.33696 11 8 11H12C12.1326 11 12.2598 11.0527 12.3536 11.1464C12.4473 11.2402 12.5 11.3674 12.5 11.5C12.5 11.6326 12.4473 11.7598 12.3536 11.8536C12.2598 11.9473 12.1326 12 12 12H6.5Z" />
      </symbol>

      <symbol id="mouse">
        <path
          d="M7.141 2C5.559 2 4.754 2.169 4.013 2.565C3.39502 2.89015 2.89015 3.39502 2.565 4.013C2.169 4.753 2 5.559 2 7.14V12.858C2 14.44 2.169 15.245 2.565 15.986C2.902 16.616 3.383 17.097 4.013 17.434C4.753 17.83 5.559 17.999 7.141 17.999H8.859C10.441 17.999 11.246 17.83 11.987 17.434C12.605 17.1089 13.1098 16.604 13.435 15.986C13.831 15.246 14 14.44 14 12.858V7.14C14 5.558 13.831 4.753 13.435 4.012C13.1098 3.39402 12.605 2.88915 11.987 2.564C11.247 2.169 10.441 2 8.86 2H7.14H7.141ZM7.141 0H8.859C10.873 0 11.953 0.278 12.931 0.801C13.8973 1.31249 14.6875 2.10269 15.199 3.069C15.722 4.047 16 5.127 16 7.141V12.859C16 14.873 15.722 15.953 15.199 16.931C14.6875 17.8973 13.8973 18.6875 12.931 19.199C11.953 19.722 10.873 20 8.859 20H7.14C5.126 20 4.046 19.722 3.068 19.199C2.10169 18.6875 1.31149 17.8973 0.8 16.931C0.278 15.953 0 14.873 0 12.859V7.14C0 5.126 0.278 4.046 0.801 3.068C1.31292 2.10192 2.10347 1.31206 3.07 0.801C4.047 0.278 5.127 0 7.141 0ZM7 4H9V9H7V4Z"
          fill="#6B7280"
        />
      </symbol>
      <symbol id="payment">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.3337 8.33317H1.66699M9.16699 11.6665H5.00033M1.66699 6.83317L1.66699 13.1665C1.66699 14.0999 1.66699 14.5666 1.84865 14.9232C2.00844 15.2368 2.2634 15.4917 2.57701 15.6515C2.93353 15.8332 3.40024 15.8332 4.33366 15.8332L15.667 15.8332C16.6004 15.8332 17.0671 15.8332 17.4236 15.6515C17.7372 15.4917 17.9922 15.2368 18.152 14.9232C18.3337 14.5666 18.3337 14.0999 18.3337 13.1665V6.83317C18.3337 5.89975 18.3337 5.43304 18.152 5.07652C17.9922 4.76292 17.7372 4.50795 17.4236 4.34816C17.0671 4.16651 16.6004 4.16651 15.667 4.1665L4.33366 4.1665C3.40024 4.1665 2.93353 4.1665 2.57701 4.34816C2.2634 4.50795 2.00844 4.76292 1.84865 5.07652C1.66699 5.43304 1.66699 5.89975 1.66699 6.83317Z"
            stroke="#40424A"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </symbol>
      <symbol id="right-arrow">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.0003 12L7 4.99969L8.99969 3L17.9997 12L8.99969 21L7 19.0003L14.0003 12Z"
            fill="#555A65"
          />
        </svg>
      </symbol>
      <symbol id="radio-selected">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="11.9996" cy="11.9996" r="8.4" fill="white" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 12C0 18.6276 5.3724 24 12 24C18.6276 24 24 18.6276 24 12C24 5.3724 18.6276 0 12 0C5.3724 0 0 5.3724 0 12ZM19.287 8.31496L10.803 16.8002L5.71143 11.7086L7.40823 10.0118L10.803 13.4066L17.5902 6.61816L19.287 8.31496Z"
            fill="#FF7420"
          />
        </svg>
      </symbol>

      <symbol id="radio-unselected">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="12" r="11" stroke="#A9AEB7" stroke-width="2" />
        </svg>
      </symbol>

      <symbol id="dropdown-icon">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_16258_21173)">
            <path
              d="M10.0006 10.9766L14.1256 6.85156L15.3039 8.0299L10.0006 13.3332L4.69727 8.0299L5.8756 6.85156L10.0006 10.9766Z"
              fill="black"
            />
          </g>
          <defs>
            <clipPath id="clip0_16258_21173">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </symbol>

      <symbol id="coin-hands">
        <svg
          width="20"
          height="21"
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_16419_11977)">
            <path
              d="M11.2749 7.1062C10.7979 7.44628 10.2141 7.64632 9.58366 7.64632C7.97283 7.64632 6.66699 6.34049 6.66699 4.72966C6.66699 3.11882 7.97283 1.81299 9.58366 1.81299C10.6278 1.81299 11.5438 2.36167 12.0591 3.18644M5.00033 16.8856H7.17557C7.45918 16.8856 7.74106 16.9194 8.016 16.9869L10.3144 17.5454C10.8131 17.6669 11.3326 17.6787 11.8366 17.5808L14.3778 17.0864C15.0491 16.9556 15.6666 16.6342 16.1506 16.1634L17.9486 14.4144C18.462 13.9158 18.462 13.1067 17.9486 12.6072C17.4863 12.1575 16.7543 12.1069 16.2313 12.4882L14.1358 14.017C13.8357 14.2364 13.4706 14.3545 13.095 14.3545H11.0716L12.3595 14.3545C13.0855 14.3545 13.6735 13.7824 13.6735 13.0763V12.8206C13.6735 12.2342 13.2633 11.723 12.6787 11.5812L10.6908 11.0978C10.3673 11.0193 10.036 10.9797 9.70294 10.9797C8.89894 10.9797 7.44357 11.6453 7.44357 11.6453L5.00033 12.6671M16.667 5.56299C16.667 7.17382 15.3612 8.47966 13.7503 8.47966C12.1395 8.47966 10.8337 7.17382 10.8337 5.56299C10.8337 3.95216 12.1395 2.64632 13.7503 2.64632C15.3612 2.64632 16.667 3.95216 16.667 5.56299ZM1.66699 12.313L1.66699 17.1463C1.66699 17.613 1.66699 17.8464 1.75782 18.0246C1.83771 18.1814 1.9652 18.3089 2.122 18.3888C2.30026 18.4797 2.53361 18.4797 3.00033 18.4797H3.66699C4.1337 18.4797 4.36706 18.4797 4.54532 18.3888C4.70212 18.3089 4.8296 18.1814 4.9095 18.0246C5.00033 17.8464 5.00033 17.613 5.00033 17.1463V12.313C5.00033 11.8463 5.00033 11.6129 4.9095 11.4347C4.8296 11.2779 4.70212 11.1504 4.54532 11.0705C4.36706 10.9797 4.1337 10.9797 3.66699 10.9797L3.00033 10.9797C2.53362 10.9797 2.30026 10.9797 2.122 11.0705C1.9652 11.1504 1.83771 11.2779 1.75782 11.4347C1.66699 11.6129 1.66699 11.8463 1.66699 12.313Z"
              stroke="#FF7420"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_16419_11977">
              <rect
                width="20"
                height="20"
                fill="white"
                transform="translate(0 0.146484)"
              />
            </clipPath>
          </defs>
        </svg>
      </symbol>
    </defs>
  </svg>
);

function iconColor(color: Color): string {
  switch (color) {
    case 'primary':
      return 'text-primary';
    case 'secondary':
      return 'text-secondary';
    case 'accent':
      return 'text-blue-400';
    case 'danger':
      return 'text-red-500';
    case 'white':
      return 'text-white';
    case 'success':
    case 'green':
      return 'text-green-500';
    case 'gray':
      return 'text-gray-400';
    case 'darkgray':
      return 'text-gray-800';
    case 'orange':
      return 'primary-DEFAULT';
    default:
      throw new Error(`Invalid color: ${color}`);
  }
}

function Icon({
  name,
  color,
  size = 1,
  baseSize = 16,
  className,
  outline,
  viewBox,
  disabled = false,
}: IconProps) {
  const widthHeight = baseSize * size;
  const calculatedSize = `${widthHeight}px`;
  const viewBoxStr = viewBox || '0 0 24 24';
  let currentColor = 'currentColor';
  switch (color) {
    case 'orange':
      currentColor = '#FF7420';
      break;
    case 'gray':
      currentColor = '#9CA3AF';
      break;
    case 'green':
    case 'success':
      currentColor = '#48BB78';
      break;
    default:
  }

  return (
    <svg
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox={viewBoxStr}
      className={`${color ? iconColor(color) : ''} ${className || ''}`}
      style={{ inlineSize: calculatedSize }}
    >
      {!outline && (
        <use
          xlinkHref={`#${name}`}
          fill={disabled ? '#D1D5DB' : currentColor}
        />
      )}
      {outline && (
        <use
          xlinkHref={`#${name}`}
          stroke={disabled ? '#D1D5DB' : currentColor}
        />
      )}
    </svg>
  );
}

Icon.defaultProps = {
  size: 1,
};

export default Icon;
